import { useEffect, useRef, useState } from "react";
import "./Styles/Home.css";
import api from "../Contexts/BaseUrl";
import LeftNavigationBar from "../Components/LeftNavigationBar";
import uploadImageIcon from "../Images/Equipments/uploadImage.png";
import { Spinner } from "react-activity";
import { toast } from "react-toastify";

export default function Home() {
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const [token, setToken] = useState(null);

  const [totalWorkoutPrograms, setTotalWorkoutPrograms] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [countMonthly, setCountMonthly] = useState(0);
  const [countYearly, setCountYearly] = useState(0);
  const [countLifetime, setCountLifetime] = useState(0);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [yearlyTotal, setYearlyTotal] = useState(0);
  const [lifetimeTotal, setLifetimeTotal] = useState(0);
  const [lastDayTotal, setLastDayTotal] = useState(0);
  const [pdfFile, setPdfFile] = useState(null);
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  const hiddenInputVideoUpload = useRef(null);
  const [tempUploadedPDFUrl, setTempUploadedPDFUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("auth"));
    if (user) {
      setToken(user.token);
    }

    api
      .get("/workoutprograms/total-programs", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setTotalWorkoutPrograms(response.data);
      });

    api
      .get("/payments/total-revenue", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setTotalRevenue(response.data);
      });

    api
      .get("/payments/count-monthly-subscription", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setCountMonthly(response.data);
      });

    api
      .get("/payments/count-yearly-subscription", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setCountYearly(response.data);
      });

    api
      .get("/payments/count-lifetime-subscription", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setCountLifetime(response.data);
      });

    api
      .get("/payments/monthly-subscription-total", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setMonthlyTotal(response.data);
      });

    api
      .get("/payments/annual-subscription-total", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setYearlyTotal(response.data);
      });

    api
      .get("/payments/lifetime-subscription-total", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setLifetimeTotal(response.data);
      });

    api
      .get("/payments/get-last-day-payment", {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        setLastDayTotal(response.data);
      });
  }, []);

  const fetchMonthlyTotal = () => {
    api
      .get("/payments/monthly-subscription-total", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setMonthlyTotal(response.data);
      });
  };
  const handleChangeUploadedVideo = async (e) => {
    if (e.target.files.length > 0) {
      setTempUploadedPDFUrl("work");
      setPdfFile(e.target.files[0]);
      setIsLoadingPDF(true);

      // const { Location } = await uploadImage(e.target.files[0]);
      // setTempUploadedPDFUrl(Location);
      setIsLoadingPDF(false);
    }
    if (hiddenInputVideoUpload.current) {
      hiddenInputVideoUpload.current.value = "";
    }
  };

  const handleClickUploadVideo = (e) => {
    hiddenInputVideoUpload.current.click();
  };
  const handleRemovePDF = () => {
    setPdfFile(null);
    setTempUploadedPDFUrl(null);
  };

  const uploadFileHandler = async () => {
    setIsLoading(true);

    const formdata = new FormData();
    formdata.append("file", pdfFile); // pdfFile should be a File object

    try {
      const response = await api.post(
        "/MotivationPhrase/upload",
        formdata, // Pass it directly here
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // Only set Content-Type if not using FormData.
            // Axios will set the correct multipart/form-data boundary automatically
          },
        }
      );
      toast.success("File upload successful", {
        position: "top-right",
        autoClose: 2000,
        theme: "dark",
      });
      setIsLoading(false);
      setPdfFile(null);
      console.log(response, "Upload successful");
    } catch (error) {
      setIsLoading(false);
      console.error("Upload failed", error.massage);
      toast.error(error.message, {
        position: "top-right",
        autoClose: 2000,
        theme: "dark",
      });
    }
  };
  return (
    <div className="homePage">
      <LeftNavigationBar home={1} />

      <div
        style={{
          width: windowSize.current[0],
          marginLeft: 300,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="mainBody">
          <div style={{ display: "flex", marginTop: 50 }}>
            <div
              style={{
                marginTop: 30,
                marginRight: 50,
              }}
            >
              <h2 style={{ textAlign: "center" }}> Motivation File</h2>
              <input
                type="file"
                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ref={hiddenInputVideoUpload}
                onChange={handleChangeUploadedVideo}
                style={{ display: "none" }}
              />
              {!isLoading ? (
                pdfFile === null ? (
                  <div
                    onClick={handleClickUploadVideo}
                    style={{
                      cursor: "pointer",
                      width: 200,
                      marginTop: 10,
                      background: "#ffffff",
                      padding: "1px 5px",
                    }}
                  >
                    <img
                      src={uploadImageIcon}
                      alt="uploadImageIcon"
                      style={{
                        maxHeight: 150,
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: 40,
                      }}
                    />
                    <li
                      style={{
                        fontFamily: "LexendBold700",
                        fontSize: 18,
                        textAlign: "center",
                        marginTop: 25,
                      }}
                    >
                      Select File
                    </li>
                    <li
                      style={{
                        fontFamily: "LexendMedium500",
                        fontSize: 12,
                        color: "#8f8d9f",
                        textAlign: "center",
                        marginTop: 5,
                        marginBottom: 40,
                      }}
                    >
                      *Only excel format is supported
                    </li>
                  </div>
                ) : (
                  <div style={{ borderStyle: "none", width: "100%" }}>
                    {pdfFile ? (
                      isLoadingPDF ? (
                        <div
                          style={{
                            marginTop: 25,
                            width: 200,
                            height: 200,
                          }}
                        >
                          <Spinner
                            style={{
                              color: "black",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: 250,
                            backgroundColor: "#ffffff",
                            padding: 10,
                            marginTop: 10,
                          }}
                        >
                          <p>{pdfFile.name}</p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: 250,
                              alignItems: "center",
                            }}
                          >
                            <button
                              style={{
                                display: "block",
                                marginTop: 10,
                                fontFamily: "LexendRegular400",
                                fontSize: 14,
                              }}
                              onClick={uploadFileHandler}
                            >
                              Upload File
                            </button>
                            <button
                              onClick={handleRemovePDF}
                              style={{
                                display: "block",
                                marginTop: 10,
                                fontFamily: "LexendRegular400",
                                fontSize: 14,
                              }}
                            >
                              Remove PDF
                            </button>
                          </div>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                )
              ) : (
                <Spinner
                  size={15}
                  color="black"
                  style={{ diplay: "block", margin: "auto" }}
                />
              )}
            </div>
            <div style={{ marginTop: 50, width: 420, background: "#ffffff" }}>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendMedium500",
                  fontSize: 24,
                  paddingTop: 50,
                  color: "#8f8d9f",
                }}
              >
                Total Programs
              </li>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendBold700",
                  fontSize: 50,
                  paddingTop: 10,
                  paddingBottom: 50,
                }}
              >
                {totalWorkoutPrograms}
              </li>
            </div>
          </div>

          <div style={{ display: "flex", marginTop: 50 }}>
            <div style={{ width: 420, background: "#ffffff" }}>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendMedium500",
                  fontSize: 24,
                  paddingTop: 50,
                  color: "#8f8d9f",
                  textAlign: "center",
                }}
              >
                Last 24hr Sell
              </li>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendSemiBold600",
                  fontSize: 50,
                  paddingTop: 10,
                  textAlign: "center",
                }}
              >
                ${lastDayTotal.toFixed(2)}
              </li>
              <div style={{ width: "100%" }}>
                <li
                  style={{
                    marginLeft: 25,
                    fontFamily: "LexendMedium500",
                    fontSize: 22,
                    color: "#8f8d9f",
                    textAlign: "center",
                    paddingTop: 10,
                    paddingBottom: 50,
                  }}
                >
                  Total Sell
                </li>
              </div>
            </div>
            <div style={{ width: 420, background: "#ffffff", marginLeft: 60 }}>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendMedium500",
                  fontSize: 24,
                  paddingTop: 50,
                  color: "#8f8d9f",
                  textAlign: "center",
                }}
              >
                All Time
              </li>
              <li
                style={{
                  marginLeft: 25,
                  fontFamily: "LexendBold700",
                  fontSize: 50,
                  paddingTop: 10,
                  textAlign: "center",
                }}
              >
                ${totalRevenue.toFixed(2)}
              </li>
              <div style={{ width: "100%" }}>
                <li
                  style={{
                    marginLeft: 25,
                    fontFamily: "LexendMedium500",
                    fontSize: 22,
                    color: "#8f8d9f",
                    textAlign: "center",
                    paddingTop: 10,
                    paddingBottom: 50,
                  }}
                >
                  Total Sell
                </li>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 50,
              paddingBottom: 50,
            }}
          >
            <div style={{ width: 266, backgroundColor: "#DEE0F8" }}>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 20,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                }}
              >
                Monthly Subscriptions
              </li>
              <li
                style={{
                  marginTop: 70,
                  marginLeft: 20,
                  fontFamily: "LexendSemiBold600",
                  fontSize: 44,
                }}
              >
                ${monthlyTotal.toFixed(2)}
              </li>
              <li
                style={{
                  marginLeft: 20,
                  fontSize: 14,
                  fontFamily: "LexendMedium500",
                  marginTop: 5,
                  color: "#75789E",
                }}
              >
                Total Revenue
              </li>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 70,
                  paddingBottom: 20,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                  color: "#75789E",
                }}
              >
                Total: <span style={{ color: "black" }}>{countMonthly}</span>
              </li>
            </div>
            <div style={{ width: 266, backgroundColor: "#E1EAED" }}>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 20,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                }}
              >
                Yearly Subscriptions
              </li>
              <li
                style={{
                  marginTop: 70,
                  marginLeft: 20,
                  fontFamily: "LexendSemiBold600",
                  fontSize: 44,
                }}
              >
                ${yearlyTotal.toFixed(2)}
              </li>
              <li
                style={{
                  marginLeft: 20,
                  fontSize: 14,
                  fontFamily: "LexendMedium500",
                  marginTop: 5,
                  color: "#75789E",
                }}
              >
                Total Revenue
              </li>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 70,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                  color: "#75789E",
                }}
              >
                Total: <span style={{ color: "black" }}>{countYearly}</span>
              </li>
            </div>
            <div style={{ width: 266, backgroundColor: "#EDEBE1" }}>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 20,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                }}
              >
                Lifetime Subscriptions
              </li>
              <li
                style={{
                  marginTop: 70,
                  marginLeft: 20,
                  fontFamily: "LexendSemiBold600",
                  fontSize: 44,
                }}
              >
                ${lifetimeTotal.toFixed(2)}
              </li>
              <li
                style={{
                  marginLeft: 20,
                  fontSize: 14,
                  fontFamily: "LexendMedium500",
                  marginTop: 5,
                  color: "#75789E",
                }}
              >
                Total Revenue
              </li>
              <li
                style={{
                  marginLeft: 20,
                  marginTop: 70,
                  paddingBottom: 20,
                  fontFamily: "LexendMedium500",
                  fontSize: 18,
                  color: "#75789E",
                }}
              >
                Total: <span style={{ color: "black" }}>{countLifetime}</span>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
